import React, { useEffect } from 'react';

import SimpleHeader from '../../../../components/Headers/SimpleHeader'
import Form from './Form'

const New: React.FC = () => {
  return (
    <>
      <SimpleHeader name="Nova Política de Privacidade" parentName="Políticas de Privacidade" />
      <Form />
    </>
  )
}

export default New;